<script setup lang="ts">
import ContentfulWidget from '~/components/widget/ContentfulWidget.vue'
</script>

<template class="mx-auto container">
  <div>
    <ContentfulWidget />
  </div>
</template>

<style scoped lang="scss">
@media (min-width: 1241px) {
  * {
    display: flex;
    justify-content: center;
  }
}
</style>
